import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <a href="https://github.com/AdelJav/weather-app">Open-source code</a> by
      Adela
    </div>
  );
}
